<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border
                 :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <FormItem
                label="姓名"
                prop="pname"
              >
                <Input
                  v-model="formValidate.pname"
                  placeholder="请输入姓名"
                ></Input>
              </FormItem>
              <FormItem
                label="身份证"
                prop="idcard"
              >
                <Input
                  v-model="formValidate.idcard"
                  placeholder="请输入身份证"
                ></Input>
              </FormItem>
              <FormItem
                label="电话"
                prop="phone"
              >
                <Input
                  v-model="formValidate.phone"
                  placeholder="请输入电话"
                ></Input>
              </FormItem>
              <FormItem
                label="籍贯"
                prop="residence"
              >
                <Input
                  v-model="formValidate.residence"
                  placeholder="请输入籍贯"
                ></Input>
              </FormItem>
              <FormItem
                label="来源地"
                prop="fromaddress"
              >
                <Input
                  v-model="formValidate.fromaddress"
                  placeholder="请输入来源地"
                ></Input>
              </FormItem>
              <FormItem
                label="现居住地"
                prop="nowaddress"
              >
                <Input
                  v-model="formValidate.nowaddress"
                  placeholder="请输入现居住地"
                ></Input>
              </FormItem>
              <FormItem
                label="疫苗接种"
                prop="vaccines"
              >
                <Input
                  v-model="formValidate.vaccines"
                  placeholder="请输入疫苗接种"
                ></Input>
              </FormItem>
              <FormItem
                label="48小时核酸"
                prop="nucleic48"
              >
                <Input
                  v-model="formValidate.nucleic48"
                  placeholder="请输入48小时核酸"
                ></Input>
              </FormItem>
              <FormItem
                label="用工单位"
                prop="company"
              >
                <Input
                  v-model="formValidate.company"
                  placeholder="请输入用工单位"
                ></Input>
              </FormItem>
              <FormItem
                label="入职时间"
                prop="intime"
              >
                <DatePicker type="date" editable v-model="formValidate.intime" format="yyyy-MM-dd"
                            placement="bottom-end" placeholder="请选择入职时间"></DatePicker>
              </FormItem>
              <FormItem
                label="到用工单位时间"
                prop="dwintime"
              >
                <DatePicker type="date" editable v-model="formValidate.dwintime" format="yyyy-MM-dd"
                            placement="bottom-end" placeholder="请选择到用工单位时间"></DatePicker>
              </FormItem>
              <FormItem
                label="离职时间"
                prop="outtime"
              >
                <DatePicker type="date" editable v-model="formValidate.outtime" format="yyyy-MM-dd"
                            placement="bottom-end" placeholder="请选择离职时间"></DatePicker>
              </FormItem>
              <FormItem
                label="状态参数"
                prop="state"
              >
                <el-select
                  v-model="formValidate.state"
                  filterable
                  default-first-option
                  placeholder="请选择状态">
                  <el-option
                    v-for="item in stateList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>
            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>

import {
  getDispatchpersonlist,
  operationDispatchperson
} from '@/api/dispatch/dispatchperson.js'
import { getsysparameterList } from '@/api/system/sys_parameter'

let moment = require('moment')
export default {
  data () {
    return {
      spinShow: false,
      fullscreenLoading: false,
      stateList: [],
      formValidate: {},
      searchVal: '',
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: '新建'
      },
      tableSelectIdList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数

      ruleValidate: {
        pname: [
          {
            required: true,
            message: '姓名不能为空',
            trigger: 'blur'
          }
        ],
         idcard: [
          {
            required: true,
            message: '身份证不能为空',
            trigger: 'blur'
          }
        ],
         phone: [
          {
            required: true,
            message: '电话不能为空',
            trigger: 'blur'
          }
        ],
         residence: [
          {
            required: true,
            message: '籍贯不能为空',
            trigger: 'blur'
          }
        ],
         fromaddress: [
          {
            required: true,
            message: '来源地不能为空',
            trigger: 'blur'
          }
        ],
         nowaddress: [
          {
            required: true,
            message: '现居住地不能为空',
            trigger: 'blur'
          }
        ],
         vaccines: [
          {
            required: true,
            message: '疫苗接种不能为空',
            trigger: 'blur'
          }
        ],
         nucleic48: [
          {
            required: true,
            message: '48小时核酸不能为空',
            trigger: 'blur'
          }
        ],
         company: [
          {
            required: true,
            message: '用工单位不能为空',
            trigger: 'blur'
          }
        ],
         intime: [
          {
            required: true,
            type: 'date',
            message: '请选择入职时间',
            trigger: 'change'
          }
        ],
         dwintime: [
          {
            required: true,
            type: 'date',
            message: '请选择到用工单位时间',
            trigger: 'change'
          }
        ],
         outtime: [
          {
            required: true,
            type: 'date',
            message: '请选择离职时间',
            trigger: 'change'
          }
        ],
         state: [
          {
            required: true,
            message: '请选择状态',
            trigger: 'change'
          }
        ]
      },
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '姓名',
          key: 'pname',
          width: 100,
          align: 'center',
          fixed: 'left',
          sortable: true
        },
         {
          title: '身份证',
          key: 'idcard',
          width: 180,
          fixed: 'left',
          align: 'center',
          sortable: true
        },
         {
          title: '电话',
          key: 'phone',
          width: 150,
          align: 'center',
          sortable: true
        },
         {
          title: '籍贯',
          key: 'residence',
          width: 180,
          align: 'center',
          sortable: true
        },
         {
          title: '来源地',
          key: 'fromaddress',
          width: 180,
          align: 'center',
          sortable: true
        },
         {
          title: '现居住地',
          key: 'nowaddress',
          width: 200,
          align: 'center',
          sortable: true
        },
         {
          title: '疫苗接种',
          key: 'vaccines',
          width: 120,
          align: 'center',
          sortable: true
        },
         {
          title: '48小时核酸',
          key: 'nucleic48',
          width: 120,
          align: 'center',
          sortable: true
        },
         {
          title: '用工单位',
          key: 'company',
          width: 220,
          fixed: 'right',
          align: 'center',
          sortable: true
        },
         {
          title: '入职时间',
          key: 'intime',
          width: 130,
          align: 'center',
          sortable: true
        },
         {
          title: '到用工单位时间',
          key: 'dwintime',
          width: 140,
          align: 'center',
          sortable: true
        },
         {
          title: '离职时间',
          key: 'outtime',
          width: 130,
          align: 'center',
          sortable: true
        },
         {
          title: '状态',
          key: 'state_CN',
          width: 100,
          fixed: 'right',
          align: 'center',
          sortable: true
        },
         {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.delData(params)
                    }
                  }
                },
                '删除'
              )
            ])
          }
        }
      ]
    }
  },
  methods: {
    getDispatchpersonlist (key, value) {
      this.spinShow = true
      getDispatchpersonlist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          this.tableData = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    getParameterList () {
      getsysparameterList('dispatch_person', 'state').then(res => {
        if (res.data.code === 0) {
          this.stateList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    handleSelectChange (val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.id)
      })
      this.tableSelectIdList = SelectIdList
    },
    closeModal () {
      this.dialog.show = false
    },
    editModal (paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true
      this.modalMap.modalTitle = mtitle
      this.editModalData = meth
      this.getParameterList()
      var day2 = new Date()
      day2.setTime(day2.getTime())
      var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
      if (paramsRow && paramsRow.id) {
        this.formValidate = {
          id: paramsRow.id,
          pname: paramsRow.pname,
          idcard: paramsRow.idcard,
          phone: paramsRow.phone,
          residence: paramsRow.residence,
          fromaddress: paramsRow.fromaddress,
          nowaddress: paramsRow.nowaddress,
          vaccines: paramsRow.vaccines,
          nucleic48: paramsRow.nucleic48,
          company: paramsRow.company,
          intime: paramsRow.intime,
          dwintime: paramsRow.dwintime,
          outtime: paramsRow.outtime,
          state: paramsRow.state
        }
      } else {
        this.formValidate = {
          id: 0,
          pname: '',
          idcard: '',
          phone: '',
          residence: '',
          fromaddress: '',
          nowaddress: '',
          vaccines: '',
          nucleic48: '',
          company: '',
          intime: s2,
          dwintime: s2,
          outtime: s2,
          state: ''
        }
      }
    },
    handleSubmit (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.formValidate.intime = moment(this.formValidate.intime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            this.formValidate.dwintime = moment(this.formValidate.dwintime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            this.formValidate.outtime = moment(this.formValidate.outtime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            operationDispatchperson(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getDispatchpersonlist(this.searchVal)
                } else {
                  this.getDispatchpersonlist()
                }
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
        } else {
          this.$Message.error('缺少必要参数')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    handlerDelete () {
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中数据嘛？ `)) {
          operationDispatchperson({ 'id_list': this.tableSelectIdList }, 'delete').then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)
              this.getDispatchpersonlist(this.searchVal)
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    delData (params) {
      if (confirm(`确定要删除该信息吗？`)) {
        operationDispatchperson(
          {
            'id': params.row.id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    changePage (value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getDispatchpersonlist(this.searchVal)
      } else {
        this.getDispatchpersonlist()
      }
    },
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getDispatchpersonlist(this.searchVal)
      } else {
        this.getDispatchpersonlist()
      }
    },
    searchinput () {
      if (this.searchVal) {
        this.getDispatchpersonlist(this.searchVal)
      } else {
        this.getDispatchpersonlist()
      }
    }
  },
  watch: {
    searchVal (val) {
      this.searchVal = val
    }
  },
  mounted () {
    this.getDispatchpersonlist()
  }
}
</script>
<style lang="less" scoped>
.search-con {
  padding: 10px 0;

  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }

    &-input {
      display: inline-block;
      width: 200px;
      margin-left: 2px;
    }

    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
